import { Brand, createBranded } from '@deltasierra/type-utilities';

/**
 * @deprecated Use the `LearnSubSectionId` instead.
 */
export type TryThisSubSectionId = Brand<number, 'TryThisSubSectionId'>;
/**
 * @deprecated Use the `LearnSubSectionId` instead.
 */
export const TryThisSubSectionId = createBranded<TryThisSubSectionId>();
